import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const Header = ({ onOpenStats, onOpenHelp }) => {
  const location = useLocation();
  const isCountriesPage = location.pathname === '/countries';

  return (
    <header className="bg-white shadow-sm border-b border-gray-100">
      <div className="container mx-auto px-4 py-4 md:py-6">
        <div className="flex items-center justify-between">
          {/* Навигация слева */}
          <div className="w-24 hidden sm:flex sm:items-center sm:gap-2">
            {!isCountriesPage && (
              <Link
                to="/countries"
                className="p-2 text-gray-600 hover:text-primary-600 hover:bg-primary-50 rounded-lg transition-colors"
                title="VPN локации"
              >
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </Link>
            )}
          </div>
          
          {/* Заголовок по центру */}
          <div className="text-center flex-1">
            <h1 className="text-2xl md:text-3xl font-bold text-gradient mb-2">
              {isCountriesPage ? 'Управление VPN локациями' : 'Восстановление подписок VLESS'}
            </h1>
            <p className="text-gray-600 text-sm md:text-lg px-2">
              {isCountriesPage 
                ? 'Добавляйте страны или выбирайте существующие для VPN локаций'
                : 'Получите новую подписку по номеру заказа с Яндекс Маркета'
              }
            </p>
          </div>
          
          {/* Кнопки действий справа */}
          <div className="flex items-center gap-2">
            {onOpenStats && !isCountriesPage && (
              <button
                onClick={onOpenStats}
                className="p-2 text-gray-600 hover:text-primary-600 hover:bg-primary-50 rounded-lg transition-colors"
                title="Моя статистика (Ctrl+M)"
              >
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
                </svg>
              </button>
            )}
            {onOpenHelp && !isCountriesPage && (
              <button
                onClick={onOpenHelp}
                className="p-2 text-gray-600 hover:text-primary-600 hover:bg-primary-50 rounded-lg transition-colors"
                title="Горячие клавиши (Ctrl+?)"
              >
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </button>
            )}
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
